<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="450px"
    @close="$router.replace('/users/categories')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="userCategory"
      :rules="rules"
      ref="userCategoryForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input
          v-model="userCategory.name"
        />
      </el-form-item>
      <el-form-item
        prop="availableParents"
        label="Szülő kategória"
      >
        <el-cascader
          v-model="userCategory.parent_id"
          :options="userCategory.availableParents"
          :props="{ checkStrictly: true, label: 'name', value: 'id', emitPath: false }"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/users/categories')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'userCategoryId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        userCategory: {},
        rules: {
          name: [
            { required: true, message: 'Mező megadása kötelező', trigger: 'change' }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Felhasználói csoport';
        } else if (this.type === 'update') {
          return 'Felhasználói csoport módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    methods: {
      async add() {
        this.$refs['userCategoryForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('userCategory/create', this.userCategory);
              } else if (this.type === 'update') {
                await this.$store.dispatch('userCategory/update', this.userCategory);
              }
              this.$store.dispatch('userCategory/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/users/categories');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },
    async mounted() {
      this.loading = true;
      if (this.userCategoryId) {
        this.userCategory = await this.$store.dispatch('userCategory/fetch', this.userCategoryId);
      } else {
        this.userCategory.availableParents = this.$store.getters['userCategory/userCategories'];
      }
      this.loading = false;
    },
  };
</script>
